import {all} from 'redux-saga/effects'

import {watchFetchLoadsSaga,watchSelectedLoadSaga, watchLoadUpdatedSaga,
  watchSetLoadPrioritySaga, watchPostLoadSaga, watchUnpostLoadSaga, watchLoadTruckOnlySelectedSaga,
  watchFetchAllEmailsSaga, watchUpdateEmailsSaga, watchFetchSelectedLoadSaga, watchFetchConnectLogsSaga,
  watchFetchInsightDataSaga, watchFetchDatRatesSaga, watchAddQueryCounterSaga, 
  watchFetchInsightHistoricLeadsSaga,watchNextLoadsSaga, watchFetchOpportunityLoadsSaga,
  watchFetchQueryCounterSaga,  watchAddThresholdOnLoadSaga, watchSetLoadTeamSaga,
  watchFetchSpreadRecapLoadsSaga
} from './sagas/loadSaga'
import {watchUserLoginSaga, watchImpersonate, watchClearImpersonateUser, watchRefreshUserTokenSaga} from './sagas/authUserSaga'
import {watchFetchMatchedTrucks, watchFetchTrucksWithFilterSaga, watchMatchedTruckBidSaga, watchAddDATTruckToCarrierSaga} from './sagas/truckSaga'
import {watchAddBidSaga, watchBidAddedEventSaga, watchAddLeadBidSaga, watchFetchBidsByFilterSaga, watchDeclineMultipleLoadsBidSaga} from './sagas/bidSaga'
import {watchFetchAndSetConnectQueueStatusSaga} from './sagas/connectQueueStatusSaga'
import {
    watchFetchCarrierByMCSaga,
    watchFetchCarrierSaga,
     watchFetchCarriersWithFilterSaga, 
    watchSelectedCarrierSaga,
    watchCarrierTruckSelectedSaga, 
    watchTruckRefreshSaga,
    watchDeleteSelectedCarrierContact, watchDeleteSelectedCarrierNote,
    watchSaveFolderUpdatesSaga,
    watchFetchCarrierFoldersSaga,
    watchAddCarrierFolderSaga,
    watchUpdateCarrierFolderSaga,
    watchDeleteCarrierFolderSaga,
    watchFetchCarrierMatchingLoadsSaga,
    watchFetchCarrierNextLoadsSaga,
    watchSelectCarrierLoadSaga,
    watchAddCarrierLoadMatchEventSaga,
    watchRemoveCarrierLoadMatchEventSaga,
    watchFetchUserCarriersSaga,
    watchFetchUserOwnedCarriersSaga,
    watchAddUserCarrierSaga,
    watchDeleteUserCarrierSaga,
    watchSetCarrierDeadheadSaga,
    watchFetchCarrierOwnersSaga,
    watchRevokeCarrierOwnerSaga,
    watchAssignCarrierOwnerSaga,
    watchUpdateCarrierSaga
} from './sagas/carrierSaga'

import {watchAddNoteSaga, watchDeleteNoteSaga} from './sagas/noteSaga'
import {watchFetchSmsQueueLogsSaga} from './sagas/smsQueueSaga'
import {
    watchFetchCustomerByIDSaga,
    watchFetchCustomersWithFilterSaga,
    watchSelectedCustomerSaga,
    watchFetchMyCustomerAssignmentsSaga,
    watchDeleteSelectedCustomerContact,
    watchDeleteSelectedCustomerNote,
    watchDeleteCustomerAssignment,
    watchAddCustomerAssignment,
    watchSaveCustomerFolderUpdatesSaga,
    watchFetchCustomersWithFilterAndLoadsSaga, 
    watchFetchCustomerLanesSaga,
    watchFetchCustomerContacts,
    watchFetchSfAccountByAljexAccountNumber
} from './sagas/customerSaga'

import {
    watchFetchUsersSaga, 
    watchFetchUsersWithActivityStatsSaga, 
    watchCallTableUserSelectedSage, 
    watchFetchActiveUsers,
    watchFetchUserLoads,
    watchFetchLoadsForAllUsers,
    watchFetchLoadSpreadForAllUsers,
    watchFetchUserActivitySaga,
    watchFetchTeamsAndUsersSaga
} from './sagas/userSaga'

import {
  watchTruckEntryCarrierSelected,
  watchTruckEntryAddTruck,
  watchTruckEntryDeleteTruck,
  watchTruckEntryDeleteMultipleTrucks,
  watchTruckEntryDeleteTruckSchedule,
  watchTruckScheduleRefreshSaga,
  watchTruckEntryAddTruckSchedule,
  watchTruckSchedulePatchSchedule,
} from './sagas/truckEntrySaga'

import {watchFetchExternalLoadsForLoadSaga } from './sagas/externalLoadSaga'
import {watchEventSaga, watchProcessNewAppVersionSaga, watchUserUpdateSaga} from './sagas/eventSaga'
import {
    watchInboxNotificationAddedEventSaga, 
    watchFetchInboxNotificationsSaga, 
    watchInboxNotificationsReadSaga,
    watchSendSlackDMSaga
} from './sagas/notificationSaga'
import {watchFetchHistoricLoadsForLoadSaga} from './sagas/historicLoadSaga'
import {watchTruckOriginSelectedSaga, watchTruckDestinationSelectedSaga} from './sagas/selectedTruckSaga'
import {watchFetchHistoricLoadsForScreenSaga} from './sagas/historicLoadScreenSaga'

import {watchStatsFetchEventSaga} from './sagas/statsSaga'
import {watchFetchTasksSaga, watchTaskUpdatedSaga} from './sagas/taskSaga'

import { watchFetchMatchesSaga, 
  /*watchMatchUpdatedSaga,*/ 
  watchMatchSelectedSaga, 
  watchMatchBidSaga, 
  watchMatchLockSaga, 
  watchRemoveMatchLockSaga, 
  watchRemoveMatchLockByUserSaga, 
  watchCheckLockSaga,
  watchSelectMatchForCarrierSaga
 } from './sagas/matchSaga'

import { watchLoadPostUpdateSaga, watchSetLoadPostSaga, watchUpdateLoadPostRatesSaga} from './sagas/loadPostSaga'
import { watchFetchAndSetEmailsSaga, watchSendEmailsSaga, watchSendBulkEmailsSaga, watchSetMcForEmails } from './sagas/emailSaga'
import {watchFetchAndSetInsightDataSaga} from './sagas/insightSaga'
import {watchFetchAndSetConnectLogsSaga } from './sagas/connectLogsSaga'
import {watchFetchAndSetLeadsSaga} from './sagas/leadsSaga'
import {watchFetchAndSetConnectMapsSaga, watchFetchAndSetConnectMapsStateSaga} from './sagas/connectMapsSaga'
import {watchFetchAndSetAdminCustomersSaga, watchAddThresholdOnTeamSaga} from './sagas/adminSaga'
import {watchFetchAndSetLoadThresholdSaga} from './sagas/loadThresholdSaga'

// For Carrier Ops
import { 
    watchFetchCarrierOpsTasksSaga, 
    watchSaveCarrierOpsTaskSaga,
    watchFetchAndSetSelectedCarrierOpsTask,
    watchSetSelectedCarrierForCarrierOps,
    watchFetchAndSetIncomingTextForCarrierOps,
    watchUpdateIncomingTextForCarrierOps,
    watchAssignCarrierOpsTasksSaga,
    watchSendCarrierOpsMMSSaga,
    watchAutoSaveCarrierOpsDataSaga,
    watchFetchSmsNotificationsSaga,
    watchMarkSmsNotificationReadSaga,
    watchFetchLoadTaskQuestionsSaga
} from './sagas/carrierOpsSaga'

import { watchFetchTeamSaga } from './sagas/teamSaga'

import { watchFetchHelpTextSaga } from './sagas/helpTextSaga'
import { watchBidEventSaga } from './sagas/bidEventSaga'
import {watchFetchPricingLoadsSaga, watchFetchSelectedPricingLoadSaga, watchUpdatePricingLoadChangesSaga, watchLoadPricingEventSaga} from './sagas/loadPricingSaga'
import {watchFetchCommissionSaga} from './sagas/commissionSaga'
import {watchFetchTrackingLoadsSaga, watchFetchTrackingLoadSaga, watchSetTrackingLoadSaga} from './sagas/trackingSaga'

import {watchCustomerSourcingLanesFetchSaga, watchSelectedCustomerSourcingLanesSaga} from './sourcing/sagas.js'

import {watchDeleteLoadBountySaga, watchFetchLoadBountiesSaga, watchFetchUserBountyBudgetsSaga} from './bounty/sagas.js'

export default function* rootSaga() {
  yield all([
    watchFetchLoadsSaga(),
    watchSelectedLoadSaga(),
    watchUserLoginSaga(),
    watchFetchMatchedTrucks(),
    watchAddBidSaga(),
    watchAddLeadBidSaga(),
    watchBidAddedEventSaga(),
    watchFetchCarrierByMCSaga(),
    watchFetchCarrierSaga(),
    watchFetchCarriersWithFilterSaga(),
    watchSelectedCarrierSaga(),
    watchFetchCustomerByIDSaga(),
    watchFetchCustomersWithFilterSaga(),
    watchSelectedCustomerSaga(),
    watchFetchMyCustomerAssignmentsSaga(),
    watchDeleteSelectedCustomerContact(),
    watchDeleteSelectedCustomerNote(),
    watchDeleteCustomerAssignment(),
    watchAddCustomerAssignment(),
    watchSaveCustomerFolderUpdatesSaga(),
    watchAddNoteSaga(),
    watchDeleteNoteSaga(),
    watchFetchUsersSaga(),
    watchFetchUsersWithActivityStatsSaga(),
    watchFetchActiveUsers(),
    watchFetchUserLoads(),
    watchFetchLoadsForAllUsers(),
    watchCallTableUserSelectedSage(),
    watchTruckEntryCarrierSelected(),
    watchTruckEntryAddTruck(),
    watchTruckEntryDeleteTruck(),
    watchFetchTrucksWithFilterSaga(),
    watchLoadUpdatedSaga(),
    watchMatchedTruckBidSaga(),
    watchFetchExternalLoadsForLoadSaga(),
    watchEventSaga(),
    watchProcessNewAppVersionSaga(),
    watchCarrierTruckSelectedSaga(),
    watchTruckRefreshSaga(),
    watchTruckScheduleRefreshSaga(),
    watchTruckSchedulePatchSchedule(),
    watchSetLoadPrioritySaga(),
    watchAddDATTruckToCarrierSaga(),
    watchPostLoadSaga(),
    watchUnpostLoadSaga(),
    watchDeleteSelectedCarrierContact(),
    watchInboxNotificationAddedEventSaga(),
    watchFetchInboxNotificationsSaga(),
    watchInboxNotificationsReadSaga(),
    watchSendSlackDMSaga(),
    watchDeleteSelectedCarrierNote(),
    watchFetchHistoricLoadsForLoadSaga(),
    watchTruckOriginSelectedSaga(),
    watchTruckDestinationSelectedSaga(),
    watchFetchHistoricLoadsForScreenSaga(),
    watchSaveFolderUpdatesSaga(),
    watchStatsFetchEventSaga(),
    watchImpersonate(),
    watchClearImpersonateUser(),
    watchFetchTasksSaga(),
    watchTaskUpdatedSaga(),
    watchLoadTruckOnlySelectedSaga(),
    watchFetchMatchesSaga(),
    //watchMatchUpdatedSaga(),
    watchMatchSelectedSaga(),
    watchMatchBidSaga(),
    watchFetchAllEmailsSaga(),
    watchUpdateEmailsSaga(),
    watchFetchSelectedLoadSaga(),
    watchFetchConnectLogsSaga(),
    watchFetchInsightDataSaga(),
    watchFetchDatRatesSaga(),
    watchAddQueryCounterSaga(),
    watchFetchInsightHistoricLeadsSaga(),
    watchLoadPostUpdateSaga(),
    watchSetLoadPostSaga(),
    watchNextLoadsSaga(),
    watchMatchLockSaga(),
    watchRemoveMatchLockSaga(),
    watchRemoveMatchLockByUserSaga(),
    watchCheckLockSaga(),
    watchFetchOpportunityLoadsSaga(),
    watchFetchAndSetEmailsSaga(),
    watchFetchQueryCounterSaga(),
    watchFetchAndSetInsightDataSaga(),
    watchFetchAndSetConnectLogsSaga(),
    watchFetchAndSetLeadsSaga(),
    watchFetchLoadSpreadForAllUsers(),
    watchFetchCustomersWithFilterAndLoadsSaga(),
    watchFetchSmsQueueLogsSaga(),
    watchFetchAndSetConnectMapsSaga(),
    watchFetchAndSetConnectMapsStateSaga(),
    watchFetchAndSetAdminCustomersSaga(),
    watchAddThresholdOnTeamSaga(),
    watchAddThresholdOnLoadSaga(),
    watchAddThresholdOnLoadSaga(),
    watchFetchAndSetLoadThresholdSaga(),
    watchFetchAndSetConnectQueueStatusSaga(),
    watchSendEmailsSaga(),
    watchSetMcForEmails(),
    watchSendBulkEmailsSaga(),
    watchFetchCarrierOpsTasksSaga(),
    watchSaveCarrierOpsTaskSaga(),
    watchFetchAndSetSelectedCarrierOpsTask(),
    watchSetSelectedCarrierForCarrierOps(),
    watchFetchAndSetIncomingTextForCarrierOps(),
    watchUpdateIncomingTextForCarrierOps(),
    watchAssignCarrierOpsTasksSaga(),
    watchSendCarrierOpsMMSSaga(),
    watchAutoSaveCarrierOpsDataSaga(),
    watchFetchSmsNotificationsSaga(),
    watchMarkSmsNotificationReadSaga(),
    watchFetchLoadTaskQuestionsSaga(),
    watchFetchCarrierFoldersSaga(),
    watchAddCarrierFolderSaga(),
    watchUpdateCarrierFolderSaga(),
    watchDeleteCarrierFolderSaga(), 
    watchFetchCustomerLanesSaga(),
    watchFetchCustomerContacts(),
    watchFetchSfAccountByAljexAccountNumber(),
    watchFetchCarrierMatchingLoadsSaga(),
    watchFetchCarrierNextLoadsSaga(),
    watchSelectCarrierLoadSaga(),
    watchFetchUserActivitySaga(),
    watchAddCarrierLoadMatchEventSaga(),
    watchRemoveCarrierLoadMatchEventSaga(),
    watchTruckEntryDeleteMultipleTrucks(),
    watchTruckEntryDeleteTruckSchedule(),
    watchFetchUserCarriersSaga(),
    watchFetchUserOwnedCarriersSaga(),
    watchAddUserCarrierSaga(),
    watchDeleteUserCarrierSaga(),
    watchSelectMatchForCarrierSaga(),
    watchUserUpdateSaga(),
    watchRefreshUserTokenSaga(),
    watchFetchTeamSaga(),
    watchSetLoadTeamSaga(),
    watchSetCarrierDeadheadSaga(),
    watchFetchCarrierOwnersSaga(),
    watchRevokeCarrierOwnerSaga(),
    watchAssignCarrierOwnerSaga(),
    watchFetchTeamsAndUsersSaga(),
    watchFetchSpreadRecapLoadsSaga(),
    watchFetchHelpTextSaga(),
    watchTruckEntryAddTruckSchedule(),
    watchFetchBidsByFilterSaga(),
    watchBidEventSaga(),
    watchUpdateCarrierSaga(),
    watchFetchPricingLoadsSaga(),
    watchFetchSelectedPricingLoadSaga(),
    watchUpdatePricingLoadChangesSaga(),
    watchFetchCommissionSaga(),
    watchFetchTrackingLoadsSaga(),
    watchFetchTrackingLoadSaga(),
    watchSetTrackingLoadSaga(),
    watchDeclineMultipleLoadsBidSaga(),
    watchLoadPricingEventSaga(),
    watchCustomerSourcingLanesFetchSaga(),
    watchSelectedCustomerSourcingLanesSaga(),
    watchUpdateLoadPostRatesSaga(),
    watchFetchLoadBountiesSaga(), 
    watchFetchUserBountyBudgetsSaga(),
    watchDeleteLoadBountySaga()
  ])
}

